import type { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { defaultThemeProp } from '../../theme';
import type { BaseProps, ExcludeStrict, ForwardProps } from '../../types';
import Flex from '../Flex';
import type { FlexProps } from '../Flex';
import { StyledPopover } from '../Popover';

import { StyledCard } from './Card';
import { StyledCardFooter } from './CardFooter';

export interface CardContentProps extends BaseProps {
  /** The content of the Card. */
  children: ReactNode;
  container?: ExcludeStrict<FlexProps['container'], true>;
}

export const StyledCardContent = styled.div(({ theme }) => {
  const {
    base: { breakpoints, spacing }
  } = theme;
  return css`
    ${StyledPopover} &, &:not(${StyledCard} ${StyledCard} > &) {
      position: relative;
      padding: calc(1.5 * ${spacing}) calc(${theme.components.card.padding} * 2);

      @media (width < ${breakpoints.sm}) {
        padding: ${spacing} calc(${theme.components.card.padding} * 1.5);
      }

      & + &,
      & + ${StyledCardFooter} {
        padding-block-start: 0;
      }
    }
  `;
});

StyledCardContent.defaultProps = defaultThemeProp;

const CardContent: FunctionComponent<CardContentProps & ForwardProps> = ({
  children,
  container,
  ...restProps
}: PropsWithChildren<CardContentProps & ForwardProps>) => {
  return (
    <Flex {...restProps} container={{ direction: 'column', ...container }} as={StyledCardContent}>
      {children}
    </Flex>
  );
};

export default CardContent;
